module.exports = __webpack_public_path__ + "static/media/success.d79b4d84.png";